import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=6ae61869&scoped=true"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"
import style0 from "./addEdit.vue?vue&type=style&index=0&id=6ae61869&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae61869",
  null
  
)

export default component.exports